import { DEFAULT_CONFIG } from "../core/constants";
import type { GoOfflineConfig, PWAMetadata, ResolvedGoOfflineConfig } from "../types";
import { dedupeStrings } from "./dedupe";
import { mergeDefined } from "./merge-config";

function normalizePWA(pwa: GoOfflineConfig["pwa"]): false | PWAMetadata {
  if (!pwa) {
    return false;
  }

  if (pwa === true) {
    return {};
  }

  return pwa;
}

export function normalizeConfig(config: GoOfflineConfig = {}): ResolvedGoOfflineConfig {
  const runtimeCaching = {
    ...DEFAULT_CONFIG.runtimeCaching,
    ...(config.runtimeCaching ?? {})
  };
  const callbacks = {
    ...DEFAULT_CONFIG.callbacks,
    ...(config.callbacks ?? {})
  };

  return {
    enabled: config.enabled ?? DEFAULT_CONFIG.enabled,
    debug: config.debug ?? DEFAULT_CONFIG.debug,
    swPath: config.swPath ?? DEFAULT_CONFIG.swPath,
    scope: config.scope ?? DEFAULT_CONFIG.scope,
    version: config.version ?? DEFAULT_CONFIG.version,
    offlinePage: config.offlinePage ?? DEFAULT_CONFIG.offlinePage,
    offlineImage: config.offlineImage ?? DEFAULT_CONFIG.offlineImage,
    precache: dedupeStrings([
      ...DEFAULT_CONFIG.precache,
      ...(config.precache ?? []),
      config.offlinePage ?? DEFAULT_CONFIG.offlinePage
    ]),
    pwa: normalizePWA(config.pwa),
    runtimeCaching,
    callbacks
  };
}

